import React from 'react'
import FilterPanel from './FilterPanel';
import FilterPanelReport from './FilterPanelReport';
import FilterPanelTrafficRegulation from './FilterPanelTrafficRegulation';

export default function FilterPanelSwitch(props) {
    
    
    function getStyle() {
        var height = 0;
        if(props.showHeader){
            height = 50;
        }else{
            height = 0;
        }

        return {
            width: props.width > 400 ? "400px" : props.width + "px",
            height:  "calc(100% - " + height + "px)"
        };
    }

    return (
        (()=>{
            switch(props.showFilterInfo.filterKind){
                //住民通報
                case('report'): {
                    return (
                        <FilterPanelReport
                            width={props.width}
                            onBack={props.onBack} 
                            
                            userAuthorities={props.userAuthorities}
                            showFilterInfo={props.showFilterInfo}
                            keyword={props.keyword}
                            filters={props.filters}
                            label={props.showFilterInfo.label}
                            onApplyFilter={props.onApplyFilter}
                            onApplyFilter_date={props.onApplyFilter_date}
                            onApplyFilter_noSearch={props.onApplyFilter_noSearch}
                            updateShowFiltersInfo={props.updateShowFiltersInfo}
                            onClick={props.onSearchFilterClick}
                            
                            viewtype={props.viewtype}
                            showHeader={props.showHeader}
                            getStyle={getStyle}
                        />
                    )
                }
                //通行制限
                case('trafficregulation'): {
                    return (
                        <FilterPanelTrafficRegulation
                            width={props.width}
                            onBack={props.onBack} 
                            
                            userAuthorities={props.userAuthorities}
                            showFilterInfo={props.showFilterInfo}
                            keyword={props.keyword}
                            filters={props.filters}
                            label={props.showFilterInfo.label}
                            onApplyFilter={props.onApplyFilter}
                            onApplyFilter_date={props.onApplyFilter_date}
                            onApplyFilter_noSearch={props.onApplyFilter_noSearch}
                            updateShowFiltersInfo={props.updateShowFiltersInfo}
                            onClick={props.onSearchFilterClick}
                            
                            viewtype={props.viewtype}
                            showHeader={props.showHeader}
                            getStyle={getStyle}
                        />
                    )
                }
                //写真撮影日orその他
                default:{
                    return (
                        <FilterPanel
                            width={props.width}
                            onBack={props.onBack} 
                            
                            userAuthorities={props.userAuthorities}
                            showFilterInfo={props.showFilterInfo}
                            keyword={props.keyword}
                            filters={props.filters}
                            label={props.showFilterInfo.label}
                            onApplyFilter={props.onApplyFilter}
                            onApplyFilter_date={props.onApplyFilter_date}
                            onApplyFilter_noSearch={props.onApplyFilter_noSearch}
                            
                            viewtype={props.viewtype}
                            showHeader={props.showHeader}
                            getStyle={getStyle}
                        />
                    )
                }
            }
        })()  
    );

}